import { Path } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function HomeIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Path d="M3 10.5 12 3l9 7.5" />
      <Path d="M5 9v11a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9" />
    </LineIcon>
  );
}
